import React from "react";
//outsource
import { Input, Form } from "antd";

//components

const ServiceRegularPrice = () => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="regularPrice"
      label="Regular Price"
      rules={[
        {
          pattern: /^[0-9]+$/,
          message: "Number only",
        },
      ]}
    >
      <Input type="number" placeholder="Regular Price" />
    </Form.Item>
  );
};

export default ServiceRegularPrice;
